import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { AuthService } from './api/services/auth-service';
import { API } from './api/services/api.service';
import { ES } from './api/services/es.service';

@Injectable()
export class SurveyService {

  constructor(private authService: AuthService, private api: API, private es: ES, private http:Http) { }

  NewSurvey()
  {
    //this.api.get('api/referral/');
    return this.api.get('api/new-survey');
  }

  SurveyQuestions(id:any,userid:any)
  {
    return this.api.get('api/survey-questions?id='+id+'&userid='+userid);
  }

  SurveySubmit(data:any)
  {
     return this.api.post('api/survey',data);
  }

  CheckSurvey(surveyid:any,userid:any)
  {
    return this.api.get('api/check-survey?surveyid='+surveyid+'&userid='+userid);
  }

  CheckPerviousSurvey(surveyid:any,userid:any)
  {
    return this.api.get('api/check-pervious-survey?surveyid='+surveyid+'&userid='+userid);
  }

  DeletePerviousSurvey(surveyid:any,userid:any)
  {
    return this.api.get('api/delete-pervious-survey?surveyid='+surveyid+'&userid='+userid);
  }

}



// WEBPACK FOOTER //
// ./src/app/survey.service.ts